function checkoutPayloadSignature(payload) {
  return JSON.stringify(payload ?? {});
}

function checkoutRouteError(message, cause = null) {
  const error = new Error(message);
  error.cause = cause;
  return error;
}

export async function planCheckoutSubmission({ rpc, payload, settlementReview = null }) {
  if (typeof rpc !== "function") {
    throw checkoutRouteError("Checkout is unavailable because the database connection is missing.");
  }

  const { data: rollout, error: rolloutError } = await rpc("get_ongoing_treatment_rollout");
  if (rolloutError) {
    throw checkoutRouteError(
      "Could not verify the clinic checkout release. Refresh and try again. Nothing was posted.",
      rolloutError,
    );
  }

  const enabled = rollout?.enabled === true;
  const signature = checkoutPayloadSignature(payload);

  if (!enabled) {
    if (settlementReview) {
      throw checkoutRouteError(
        "The clinic checkout release changed after review. Refresh this checkout before posting.",
      );
    }
    return {
      action: "commit",
      rpcName: payload?.fold_plan_id
        ? "commit_checkout_with_fold"
        : "commit_checkout_with_followup",
      rollout,
    };
  }

  if (settlementReview?.signature === signature) {
    return {
      action: "commit",
      rpcName: "commit_checkout_settlement",
      rollout,
    };
  }

  const { data: preview, error: previewError } = await rpc("preview_checkout_settlement", {
    p_input: payload,
  });
  if (previewError) {
    throw checkoutRouteError(
      previewError.message || "The database could not review this checkout. Nothing was posted.",
      previewError,
    );
  }
  if (preview?.valid !== true) {
    throw checkoutRouteError(
      preview?.error || "This checkout does not balance. Nothing was posted.",
    );
  }

  return {
    action: "review",
    rollout,
    review: {
      signature,
      preview,
    },
  };
}

export { checkoutPayloadSignature };
